export default "__VITE_ASSET__D8hv4YiQ__"